import script from "./SetExcludedProductsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SetExcludedProductsModal.vue?vue&type=script&setup=true&lang=js"

import "./SetExcludedProductsModal.vue?vue&type=style&index=0&id=5a2ea39b&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a2ea39b"]])

export default __exports__